import React from "react";
import { useDroppable } from "@dnd-kit/react";

const DroppableTicketStage = ({
  stageKey,
  children,
}: {
  stageKey: string;
  children: React.ReactNode;
}) => {
  const { ref, isDropTarget } = useDroppable({
    id: `ticket-stage-${stageKey}`,
    data: {
      type: "ticket-stage",
      stageKey,
    },
  });

  return (
    <div
      ref={ref}
      className={`flex-1 min-h-[100px] overflow-hidden transition-colors ${
        isDropTarget ? "bg-blue-50 dark:bg-blue-900/20" : ""
      }`}
    >
      {children}
    </div>
  );
};

export default DroppableTicketStage;
